export default "<app-manage-people-list [people]=\"people\"></app-manage-people-list>\n<input type=\"button\" (click)=\"printPerson1()\" value=\"print\">\n"